<!-- 功能定义 - 数据定义 - 维护按钮-->
<template>
<div>
  <Table
    ref="table"
    :loadObj='{}'
    :option="{}"
    :colObj='{
      opId:"105",
      name:"维护按钮",
      parentId:"OP_ID,DATA_CLASS",
      parentName:"数据定义",
      parentPath:"/system/functionSon",
      parentQuery:{
        OP_ID:$route.query.OP_ID,
        sname:$route.query.pname,
      },
      addForm:{
        OP_ID:$route.query.OP_ID,
        DATA_CLASS:$route.query.sname,
      },
      dataClass:11,
      col:[]
    }'
  >
  </Table>
</div>
</template>
<script>
import Table from '@/components/table/dataTablecSon';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
